import redirects from '#shared/data/redirects';

const withoutTrailingSlash = (path: string): string =>
    path.length > 1 ? path.replace(/\/+$/, '') : path;

const productPagePath = (path: string): string | null =>
    path.match(/^\/products\/[^/]+/)?.[0] ?? null;

export default defineNuxtRouteMiddleware((to) => {
    const path = withoutTrailingSlash(to.path);
    const productPath = productPagePath(path);
    const redirectUrl =
        redirects[path] ?? (productPath ? redirects[productPath] : undefined);

    if (redirectUrl) {
        return navigateTo(redirectUrl);
    }
});
